import ListSection from "../../../../Cards/ListSection";
import Itinerary from "../Itinerary";

interface Props {
  data: {
    itinerary?: any;
    remarks: Array<string>;
    cancellationPolicy: Array<string>;
  };
}

export default function GeneralInformation({
  data: { itinerary, remarks, cancellationPolicy },
}: Props) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "30px" }}>
      {itinerary && <Itinerary data={{ itinerary }} />}
      {remarks && <ListSection title="Remarks" items={remarks} />}
      <ListSection title="Cancel Policy" items={cancellationPolicy} />
    </div>
  );
}
